module.exports = __webpack_public_path__ + "static/img/homeNzps.301cc8d6.png";